
import { RevPicker } from '@backmarket/design-system'

import { tw } from '@core/tailwind'

import { HIGHLIGHTED_PICKERS_VARIANTS } from '../HighlightedPickers/HighlightedPickers.constants'

export default {
  components: {
    RevPicker,
  },
  props: {
    description: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Object,
      default: null,
    },
    iconProps: {
      type: Object,
      default: () => ({}),
    },
    label: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    selectedHighlightedPickers: {
      type: Object,
      default: null,
    },
    to: {
      type: Object,
      default: null,
    },
    replace: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    pickerStyle() {
      if (
        this.selectedHighlightedPickers?.type ===
          HIGHLIGHTED_PICKERS_VARIANTS.info &&
        this.selected
      ) {
        return tw`!bg-info-ultralight !border-info !text-primary`
      }

      if (
        this.selectedHighlightedPickers?.type ===
          HIGHLIGHTED_PICKERS_VARIANTS.accent &&
        this.selected
      ) {
        return tw`!bg-accent-ultralight !border-accent !text-primary`
      }

      return ''
    },
  },
}
